const actionTypes = {

    INITIALIZE_COIN: 'INITIALIZE_COIN',
    EXCHANGE_SUCCESS: 'EXCHANGE_SUCCESS',
    EXCHANGE_ERROR: 'EXCHANGE_ERROR',

    INITIALIZE: 'INITIALIZE',
    COIN_API_SUCCESS: 'COIN_API_SUCCESS',
    COIN_API_ERROR: 'COIN_API_ERROR',
}

export default actionTypes